import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Loader from "../../components/Loader";
import { crmHeaders } from "../../utils/crmApi";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function SmsTemplates() {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get(`${BASE_URL}/sms/templates`, { headers: crmHeaders() })
            .then((res) => setTemplates(res.data))
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, []);

    const searchTable = (e) => {
        const filter = e.target.value.toLowerCase();
        const rows = document.getElementById("SmsTable")?.getElementsByTagName("tr") || [];
        for (let i = 1; i < rows.length; i++) {
            const cells = rows[i].getElementsByTagName("td");
            let match = false;
            for (let j = 0; j < cells.length; j++) {
                const cellValue = cells[j]?.textContent || "";
                if (cellValue.toLowerCase().includes(filter)) {
                    match = true;
                    break;
                }
            }
            rows[i].style.display = match ? "" : "none";
        }
    };

    if (loading) return <Loader />;

    return (
        <div className="container">
            <div className="crm-page-header">
                <div>
                    <h1 className="crm-page-title">SMS Templates</h1>
                    <p className="crm-page-subtitle">
                        Use placeholders: {"{clientName}"}, {"{businessName}"}, {"{phoneNumber}"},{" "}
                        {"{email}"}
                    </p>
                </div>
                <Link to="/sms" className="btn btn-outline-secondary">
                    <i className="bi bi-arrow-left me-1"></i> Back
                </Link>
            </div>

            <div className="row g-3 mb-3">
                <div className="col-auto">
                    <Link to="/sms/addtemplate" className="btn btn-primary">
                        Add New Template
                    </Link>
                </div>
                <div className="col-sm-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search templates..."
                        onKeyUp={searchTable}
                    />
                </div>
            </div>

            <table className="table table-striped table-light" id="SmsTable">
                <thead>
                    <tr>
                        <th>Country</th>
                        <th>Template</th>
                        <th>Created</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {templates.map((template) => (
                        <tr key={template.Id}>
                            <td>{template.Country}</td>
                            <td style={{ maxWidth: 420, whiteSpace: "pre-wrap" }}>{template.Template}</td>
                            <td>{template.Created_At}</td>
                            <td>
                                <Link to={`/sms/updatetemplate/${template.Id}`}>
                                    <i className="bi bi-pencil-square text-dark"></i>
                                </Link>
                            </td>
                            <td>
                                <Link to={`/sms/deletetemplate/${template.Id}`}>
                                    <i className="bi bi-trash3 text-danger"></i>
                                </Link>
                            </td>
                        </tr>
                    ))}
                    {templates.length === 0 && (
                        <tr>
                            <td colSpan="5" className="text-center">
                                No SMS templates yet. Add your first template.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
